// Uncomment when all fields are set sortable in the API
// Currently sortable fields: https://github.com/boxcast/boxcast_api/blob/master/app/models/broadcast.rb#L150-L152
//
// import { canPaginate } from '../../mixins/can_paginate';
import { NEW_ADMIN_URL } from 'environment';

import './dashboard.scss';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/', {
        template: require('./dashboard.html'),
        controller: 'DashboardController'
    });
})
.controller('DashboardController', ($scope, $location, $filter, $timeout, $route, Broadcast, BroadcastService) => {
    // Uncomment when all fields are set sortable in the API
    // canPaginate($scope, $location);
    // $scope.s || ($scope.s = 'starts_at');

    $scope.settings = {
      showTodayGraph: false
    };

    let reloadHandle, reloadInterval = 10000;

    const params = _.pick($scope, 'q', 's', 'p');
    params["filter.exclude_disallowed_accounts"] = "true"
    params["filter.include_archived"] = "false"
    params.q = 'timeframe:preroll timeframe:current';
    params.l = 1000;
    params.include_stream_diagnostics = true;

    let broadcastData = [];
    let cleanBroadcastData = [];
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.broadcasts = [];
    $scope.loading = true;
    $scope.q = { $: '' };

    // Fetch our active broadcasts
    const load = () =>
        Broadcast.queryAll(params).then((data) => {
            broadcastData = BroadcastService.powerSort(data); // For mock data, swap `data` with `require('./fake-data.json')`
            cleanBroadcastData = broadcastData;

            // If a search term is entered, do the additional filtering by search
            if ($scope.q.$.length) broadcastData = $filter('filter')(broadcastData, $scope.q.$);

            // Refresh rate as a function of number of broadcasts....
            // <500 = 10s
            // 500-1000 = 30s
            // 1000+ = 60s
            var refreshRate = 10;
            if (broadcastData.length > 1000) {
              refreshRate = 60;
            } else if (broadcastData.length > 500) {
              refreshRate = 30;
            }

            // Apply existing sort & direction
            broadcastData = $filter('orderBy')(broadcastData, sort, reverse);

            // Update the view
            $scope.broadcasts = broadcastData;

            $scope.loading = false;

            reloadHandle = $timeout(load, reloadInterval = refreshRate*1000);
        }).catch((err) => {
            reloadInterval = Math.min(2 * reloadInterval, 120000); //exponential backoff up to 2min
            reloadHandle = $timeout(load, reloadInterval);
        });
    load();
    $scope.$on('$destroy', () => $timeout.cancel(reloadHandle));

    // UI based sort (Use until additional fields are made sortable in the API)
    let sort = localStorage.getItem('dashboard.sort') ? JSON.parse(localStorage.getItem('dashboard.sort')).field : 'starts_at';
    let reverse = localStorage.getItem('dashboard.sort') ? JSON.parse(localStorage.getItem('dashboard.sort')).reverse : false;
    localStorage.setItem('dashboard.sort', JSON.stringify({ field: sort, reverse: reverse }));
    let lastSort = sort;
    $scope.uiSort = ($event) => {
        // If the <i> tag is clicked, move upwards to grab the correct data field target
        sort = $event.target.dataset.field ? $event.target.dataset.field : $event.target.parentElement.dataset.field;
        if (sort === lastSort && sort.indexOf('-score') == -1) {
            reverse = reverse ? false : true;
        } else {
            reverse = false;
        }
        lastSort = sort;

        // Account for multiple fields being passed
        if (sort.slice(0,1) === "[") sort = JSON.parse(sort);

        // Sort the data
        broadcastData = $filter('orderBy')(broadcastData, sort, reverse);

        // If a search term is entered, do the additional filtering by search
        if ($scope.q.$.length) broadcastData = $filter('filter')(broadcastData, $scope.q.$);

        // Update the view
        $scope.broadcasts = broadcastData;

        // Store your last sort
        localStorage.setItem('dashboard.sort', JSON.stringify({ field: sort, reverse: reverse }));

        gtag('event','table_column_sorted',{ category: sort + " - " + (reverse ? 'descending' : 'ascending')})
    };

    // Display proper sort icon
    $scope.uiSortClass = (data) => {
        let classes = ['fa']
        if (sort.indexOf(data) === -1) {
            classes.push('fa-sort');
        } else if (reverse) {
            classes.push('fa-sort-alpha-desc');
        } else {
            classes.push('fa-sort-alpha-asc');
        }
        return classes.join(' ');
    };

    // Text search
    let filterTextTimeout;
    $scope.search = (q) => {
        let cleanData = angular.copy(cleanBroadcastData);
            cleanData = $filter('orderBy')(cleanData, sort, reverse);
        $scope.broadcasts = $filter('filter')(cleanData, q);

        // Our model debounce is super short, only register
        // GA4 analytics after the user stops typing.
        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
        filterTextTimeout = $timeout(function() {
            if (q.length) {
                gtag('event', 'table_searched', {category: q});
            }
        }, 1000);
    };

    // Format the Start Time Tooltip
    $scope.tooltipDateContent = (data) => {
        const sameDay = moment(data.starts_at).isSame(moment(data.stops_at), 'day');
        if (!sameDay) {
            return `Starts ${$filter('date')(data.starts_at)}<br>Stops ${$filter('date')(data.stops_at)}`;
        } else {
            return `Starts ${$filter('date')(data.starts_at)}`;
        }

    }

    // Format Accessibility (Type) Tooltip
    $scope.tooltipAccessibilityContent = (data) => {
        let tip = [];
        if (data.is_ticketed) {
            tip.push(`$` + $filter('number')(data.sold_ticket_total, 2));
            if (!$scope.bottomRows.type) tip.push(` total ($` + $filter('number')(data.ticket_price, 2) + ` each)`);
            if(data.free_variant !== 'none') {
                tip.push(`<div class="tip-row">Free: ${data.free_variant}</div>`);
            }
        }
        return tip.join('');
    };

    // Format Stats Tooltip
    $scope.tooltipStatsContent = (data) => {
        let tip = [];
        tip.push(`<div class="text-left">` + $filter('number')(data.total_active_viewer_count) + ` active viewers</div>`);
        tip.push(`<div class="text-left">` + $filter('number')(data.total_view_count) + ` total viewers</div>`);
        if (data.is_ticketed) {
            tip.push(`<div class="text-left">` + $filter('number')(data.sold_ticket_count) + ` tickets sold</div>`);
        }
        return tip.join('');
    };

    // Warn for events ending in less than 15 minutes
    $scope.warningTimeCutoff = (new Date((new Date()).getTime() + (15 * 60000))).toISOString();
    $scope.timeLeft = (stops_at) => moment(stops_at).fromNow();

    // Pop the row
    $scope.show = b => $location.url(`${NEW_ADMIN_URL}/broadcasts/${b.id}`);

    // Display extra fields in table
    $scope.extraFields = localStorage.getItem('dashboard.fields');
    if ($scope.extraFields) {
        $scope.extraFields = JSON.parse($scope.extraFields);
    } else {
        $scope.extraFields = {
            time: true,
            status: true,
            sport: true,
            make: true,
            type: true,
            source: true,
            stats: true
        };
    }

    // Display the second row
    $scope.bottomRows = localStorage.getItem('dashboard.bottomRows');
    if ($scope.bottomRows) {
        $scope.bottomRows = JSON.parse($scope.bottomRows);
    } else {
        $scope.bottomRows = {
            name: true,
            sport: false,
            make: false,
            time: false,
            status: false,
            type: false,
            stats: true
        };
    }

    $scope.toggle = function(field, e) {
        $scope.extraFields[field] = !$scope.extraFields[field];
        localStorage.setItem('dashboard.fields', JSON.stringify($scope.extraFields));
        e.preventDefault();
        e.stopPropagation();
        $route.reload();
        gtag('event', 'table_column_toggled', { category: field, label: $scope.extraFields[field] });
        return false;
    };

    $scope.toggleBottomRow = function(field, e) {
        $scope.bottomRows[field] = !$scope.bottomRows[field];
        localStorage.setItem('dashboard.bottomRows', JSON.stringify($scope.bottomRows));
        e.preventDefault();
        e.stopPropagation();
        $route.reload();
        gtag('event','table_column_bottom_row_toggled', { category: field, label: $scope.bottomRows[field] });
        return false;
    };
});


// WEBPACK FOOTER //
// ./views/dashboard/dashboard_controller.js